export const BOOKINGS_STATE_TOKEN = 'BOOKINGS';

export const BOOKINGS_API_PATHS = {
    bookings: 'client/bookings',
    past_bookings: 'client/past_bookings'
};
